import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
var _excluded = ["lazyload"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useContext } from 'react';
import clsx from 'clsx';
import Image from './Image';
import { Lazyload } from '../lazyload';
import { COMPONENT_TYPE_KEY } from '../utils/constant';
import { Icon } from '../icon';
import ConfigProviderContext from '../config-provider/ConfigProviderContext';
export var getLazyImagePlaceholder = function getLazyImagePlaceholder(bem) {
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(bem('loading'))
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "photo",
    className: clsx(bem('loading-icon'))
  }));
};

var LazyImage = function LazyImage(props) {
  var _useContext = useContext(ConfigProviderContext),
      prefixCls = _useContext.prefixCls,
      createNamespace = _useContext.createNamespace;

  var _createNamespace = createNamespace('image', prefixCls),
      _createNamespace2 = _slicedToArray(_createNamespace, 1),
      bem = _createNamespace2[0];

  var lazyload = props.lazyload,
      imageProps = _objectWithoutProperties(props, _excluded);

  var renderPlaceholder = function renderPlaceholder() {
    if (typeof lazyload === 'boolean') return getLazyImagePlaceholder(bem);
    return lazyload.placeholder || getLazyImagePlaceholder(bem);
  };

  if (lazyload) {
    var className = imageProps.className,
        style = imageProps.style,
        height = imageProps.height,
        width = imageProps.width;
    var attrs = {
      className: clsx(className, bem({
        block: imageProps.block
      })),
      style: _objectSpread(_objectSpread({}, style), {}, {
        height: height,
        width: width
      })
    };
    return /*#__PURE__*/React.createElement(Lazyload, _extends({}, attrs, {
      placeholder: renderPlaceholder()
    }), /*#__PURE__*/React.createElement(Image, imageProps));
  }

  return /*#__PURE__*/React.createElement(Image, imageProps);
};

LazyImage.defaultProps = {
  fit: 'fill',
  errorIcon: 'photo-fail',
  loadingIcon: 'photo',
  showError: true,
  showLoading: true,
  block: true
};
export var IMAGE_KEY = Symbol('image');
var ImageNamespace = Object.assign(LazyImage, _defineProperty({}, COMPONENT_TYPE_KEY, IMAGE_KEY));
export default ImageNamespace;